var _this = this;

import React, { useState, useEffect } from 'react';
import { connect, ReactReduxContext } from 'react-redux';
import { Container, Row, Col, Accordion } from 'react-bootstrap'; // Design System

import Heading from '../heading/Heading';
import NewslettForm from '../forms/Newsletter';

var NewsletterSignup = function NewsletterSignup(props) {
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      changeInputHandler = props.changeInputHandler,
      submitHandler = props.submitHandler,
      isLoading = props.isLoading,
      results = props.results;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, null, results && !results.data ?
  /*#__PURE__*/
  // {!results || results.data ? // For debugging the thank you message
  React.createElement(Row, {
    className: "row-grid"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: "6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-l-padding-large--right"
  }, /*#__PURE__*/React.createElement(Heading, {
    level: "3",
    field: model.subtitle,
    className: "cb-type__subtitle"
  }), /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: model.title,
    className: "cb-type__title"
  }))), /*#__PURE__*/React.createElement(Col, {
    sm: "6"
  }, /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
    return /*#__PURE__*/React.createElement(NewslettForm, {
      store: props.store,
      model: model,
      changeHandler: changeInputHandler,
      submitHandler: submitHandler,
      isLoading: isLoading,
      results: results
    });
  }.bind(_this)))) : /*#__PURE__*/React.createElement(Row, {
    className: "row-grid"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: "cb-type--center"
  }, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: model.thankYouMessage,
    className: "cb-type__title"
  }))))));
};

function mapStateToProps(state) {
  return {
    isLoading: state.newsletter.isLoading,
    results: state.newsletter.results
  };
}

export default connect(mapStateToProps)(NewsletterSignup);